import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "login-form" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("label", { for: "email" }, "メールアドレス", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("label", { for: "password" }, "パスワード", -1)
const _hoisted_4 = { class: "password-input-container" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", {
  id: "toggle-icon",
  class: "fas fa-eye-slash"
}, null, -1)
const _hoisted_6 = [
  _hoisted_5
]

import { withDefaults, ref, onMounted } from 'vue';
import { useRouter } from 'vue-router';
import CoreDialog from '../../../../../framework/components/dialog/CoreDialog.vue';
import { MessageDialog } from '../../../../framework/frontend/MessageDialog';
import { AuthService } from '../../../biz/remote/AuthService';
import { SessionUser } from '../../../utils/SessionUser';
import { DialogHandler } from '../../../components/dialog/DialogHandler';
import { translation } from '../../../lang/Translation';
interface Props {
  title: string;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'RegisterForm',
  props: {
    title: { default: 'Create Account Dialog ' }
  },
  setup(__props: any) {

const prop = __props as { title: string };

const t = translation;



const router = useRouter();

/**
 * リアクティブプロパティ作成ブロック
 */
const dialogTitle = ref(prop.title);
const email = ref('');
const password = ref('');
const dialogId = DialogHandler.createAccountId;
const hide = ref(true);

/**
 * アクション作成
 */
const onCreate = async () => {
  const biz = new AuthService();
  const response = await biz.createUserApi(email.value, password.value, '', 'user', 'none');

  if (response.hasError) {
    sessionStorage.clear();
    MessageDialog.alert(response.errorDescription);
  } else {
    SessionUser.saveAuthUserInSession(response.data);
    router.push('/list');
    DialogHandler.hideDialog(dialogId);
  }
};

const onCancel = () => {
  DialogHandler.hideDialog(dialogId);
};

const showPassword = () => {
  const toggleIcon = document.getElementById('toggle-icon');
  if (hide.value) {
      hide.value = false;
      // FontAwesome 5用の切り替え
      toggleIcon.classList.remove('fa-eye-slash');
      toggleIcon.classList.add('fa-eye');
    } else {
      hide.value = true;
      // FontAwesome 5用の切り替え
      toggleIcon.classList.remove('fa-eye');
      toggleIcon.classList.add('fa-eye-slash');
    }
}

/**
 * 動的名称作成
 */
// const emailTitle = ref('');
// const passTitle = ref('');
// const closeButtonTitle = ref('');

// onMounted(() => {
//   DialogHandler.onOpenDialog(dialogId, async function () {
//     dialogTitle.value = t.to('アカウント作成', 'create_account');
//     emailTitle.value = t.to('メールアドレス', 'email');
//     passTitle.value = t.to('パスワード', 'password');
//     closeButtonTitle.value = t.to('キャンセル', 'cancel');
//   });
// });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _withDirectives(_createElementVNode("input", {
      id: "email",
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((email).value = $event)),
      name: "email",
      type: "email",
      placeholder: "メールアドレスを入力",
      required: "",
      autofocus: "",
      class: "w-100"
    }, null, 512), [
      [_vModelText, email.value]
    ]),
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, [
      (hide.value === true)
        ? _withDirectives((_openBlock(), _createElementBlock("input", {
            key: 0,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((password).value = $event)),
            name: "password",
            type: "password",
            placeholder: "パスワードを入力",
            required: "",
            class: "w-100"
          }, null, 512)), [
            [_vModelText, password.value]
          ])
        : _createCommentVNode("", true),
      (hide.value === false)
        ? _withDirectives((_openBlock(), _createElementBlock("input", {
            key: 1,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((password).value = $event)),
            name: "password",
            type: "text",
            placeholder: "パスワードを入力",
            required: "",
            class: "w-100"
          }, null, 512)), [
            [_vModelText, password.value]
          ])
        : _createCommentVNode("", true),
      _createElementVNode("button", {
        id: "toggle-password",
        type: "button",
        class: "toggle-password",
        onClick: showPassword
      }, _hoisted_6)
    ]),
    _createElementVNode("button", {
      class: "submit login-form-button",
      onClick: onCreate
    }, "新規登録")
  ]))
}
}

})